import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function CookieConsent() {
  const navigate = useNavigate();

  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
      setTimeout(() => setIsVisible(true), 100);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  if (!showBanner) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-30 z-50 flex items-end justify-center p-3 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        className={`bg-white rounded-xl shadow-xl w-full max-w-xl transform transition-transform duration-300 ${
          isVisible ? "translate-y-0" : "translate-y-4"
        }`}
      >
        <div className="p-4 md:p-5">
          {/* Header */}
          <div className="flex items-start mb-2">
            <div className="flex items-center justify-center w-8 h-8 bg-[#006147] rounded-md mr-2.5">
              <svg
                className="w-4 h-4 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 14a6 6 0 110-12 6 6 0 010 12zm2-6a2 2 0 11-4 0 2 2 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-[#061619] leading-tight">
                Cookie Preferences
              </h3>
              <p className="text-xs text-[#70737A]">We value your privacy</p>
            </div>
          </div>

          {/* Content */}
          <div className="text-[#061619] mb-3 text-sm leading-snug">
            <p className="mb-1">
              We use essential cookies to improve your experience. No tracking,
              no ads — just a better site.
            </p>
            <p className="text-xs text-[#70737A]">
              Learn more in our{" "}
              <button
                  onClick={()=>navigate('/privacy-policy')}
                className="text-[#006147] underline hover:text-[#FF7F40] transition-colors font-medium"
              >
                Privacy Policy
              </button>
              .
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-row gap-2">
            <button
              onClick={handleAccept}
              className="flex-1 bg-[#006147] hover:bg-[#FF7F40] text-white px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 transform hover:scale-[1.02]"
            >
              Accept
            </button>
            <button
              onClick={handleDecline}
              className="flex-1 border border-gray-200 text-[#061619] hover:border-[#006147] hover:text-[#006147] px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-gray-50"
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}






// import { useState, useEffect } from "react";

// export default function CookieConsent() {
//   const [showBanner, setShowBanner] = useState(false);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const consent = localStorage.getItem("cookieConsent");
//     if (!consent) {
//       setShowBanner(true);
//       // Add slight delay for smooth entrance animation
//       setTimeout(() => setIsVisible(true), 100);
//     }
//   }, []);

//   const handleAccept = () => {
//     localStorage.setItem("cookieConsent", "accepted");
//     setIsVisible(false);
//     setTimeout(() => setShowBanner(false), 300);
//   };

//   const handleDecline = () => {
//     localStorage.setItem("cookieConsent", "declined");
//     setIsVisible(false);
//     setTimeout(() => setShowBanner(false), 300);
//   };

//   if (!showBanner) return null;

//   return (
//     <div className={`fixed inset-0 bg-black bg-opacity-40 z-50 flex items-end justify-center p-4 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
//       <div className={`bg-white rounded-2xl shadow-2xl max-w-2xl w-full transform transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-8'}`}>
//         <div className="p-6 md:p-8">
//           {/* Header */}
//           <div className="flex items-start mb-4">
//             <div className="flex items-center justify-center w-10 h-10 bg-[#006147] rounded-lg mr-3">
//               <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 14a6 6 0 110-12 6 6 0 010 12zm2-6a2 2 0 11-4 0 2 2 0 014 0z" clipRule="evenodd" />
//               </svg>
//             </div>
//             <div>
//               <h3 className="text-lg font-semibold text-[#061619]">Cookie Preferences</h3>
//               <p className="text-sm text-[#70737A]">We value your privacy</p>
//             </div>
//           </div>

//           {/* Content */}
//           <div className="text-[#061619] mb-6">
//             <p className="mb-3 leading-relaxed">
//               This website uses cookies to enhance your browsing experience and provide 
//               personalized services. We believe in transparency and want you to be in 
//               control of your data.
//             </p>
//             <p className="text-sm text-[#70737A] leading-relaxed">
//               We only use essential cookies to remember your preferences. No tracking, 
//               no ads, just a better experience. Learn more in our{" "}
//               <a
//                 href="/privacy"
//                 className="text-[#006147] underline hover:text-[#FF7F40] transition-colors font-medium"
//               >
//                 Privacy Policy
//               </a>
//               .
//             </p>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex flex-col sm:flex-row gap-3">
//             <button
//               onClick={handleAccept}
//               className="flex-1 bg-[#006147] hover:bg-[#FF7F40] text-white px-6 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
//             >
//               Accept All
//             </button>
//             <button
//               onClick={handleDecline}
//               className="flex-1 border-2 border-gray-200 text-[#061619] hover:border-[#006147] hover:text-[#006147] px-6 py-3 rounded-xl font-medium transition-all duration-200 hover:bg-gray-50"
//             >
//               Decline
//             </button>
//           </div>

//           {/* Additional Info */}
//           <div className="mt-4 pt-4 border-t border-gray-100">
//             <p className="text-xs text-[#70737A] text-center">
//               You can change your preferences anytime in your browser settings
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }